import ChargeVehicleBrandListView from '../../components/ChargeVehicleBrandListView';

function ChargeVehicleBrandListScreen(props) {
  return <ChargeVehicleBrandListView showFullUI={true} />;
}

export default ChargeVehicleBrandListScreen;
